// Provider registry for static map rendering and forward geocoding — same selection
// mechanism as resolveProvider.ts, mapping NUXT_PUBLIC_AUTOCOMPLETE_PROVIDER to an adapter.
import { GeocodingProviderEnum } from '~/enums'
import { selectProvider } from './selectProvider'
import type { MapProvider } from './interfaces'

const registry: Record<GeocodingProviderEnum, () => Promise<MapProvider>> = {
  [GeocodingProviderEnum.MAPBOX]: () =>
    import('./mapbox').then((module) => module.mapboxMapAdapter),
  [GeocodingProviderEnum.GOOGLE]: () => import('./google').then((module) => module.googleMapAdapter)
}

export async function resolveMapProvider(): Promise<MapProvider> {
  return registry[selectProvider(useRuntimeConfig().public)]()
}
